"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
function base64EncodeUnicode(str) {
    var replacer = function (_, p1) { return String.fromCharCode(Number("0x" + p1)); };
    var encoded = encodeURIComponent(str) // use encodeURIComponent to get percent-encoded UTF-8
        .replace(/%([0-9A-F]{2})/g, replacer); // convert the percent encodings into raw bytes
    return btoa(encoded);
}
exports.base64EncodeUnicode = base64EncodeUnicode;
function base64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str)
        .split('')
        .map(function (c) { return '%' + ("00" + c.charCodeAt(0).toString(16)).slice(-2); }) // eslint-disable-line prefer-template
        .join(''));
}
exports.base64DecodeUnicode = base64DecodeUnicode;
function appendRequestId(requestId) {
    var queryParams = qs_1.default.parse(window.location.search, { ignoreQueryPrefix: true });
    queryParams.requestId = requestId;
    var queryString = qs_1.default.stringify(queryParams, { addQueryPrefix: true });
    history.pushState('', document.title, "" + window.location.pathname + queryString);
}
exports.appendRequestId = appendRequestId;
function removeRequestId() {
    var _a = qs_1.default.parse(window.location.search, { ignoreQueryPrefix: true }), requestId = _a.requestId, queryParams = __rest(_a, ["requestId"]);
    var queryString = '';
    if (Object.getOwnPropertyNames(queryParams).length) {
        queryString = qs_1.default.stringify(queryParams, { addQueryPrefix: true });
    }
    history.pushState('', document.title, "" + window.location.pathname + queryString);
}
exports.removeRequestId = removeRequestId;
function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
}
exports.removeHash = removeHash;
//# sourceMappingURL=utils.js.map